/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';
import { IcepanelService } from '../../../../icemedx-lib/src/components/icepanel/icepanel.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { AppService } from '../app.service';

@Component({
  selector: 'app-patientregistrationcomplete',
  templateUrl: './patientregistrationcomplete.component.html',
  styleUrls: ['./patientregistrationcomplete.component.scss'],
  providers: [IcepanelService]
})
export class PatientregistrationcompleteComponent implements OnInit {
  inboxSettings: IcepanelcontainerSettings = null;
  constructor(private appsvc: AppService) { }

  ngOnInit() {

    let panelTag = "RegistrationComplete";
    let panelKey = Iceutility.guid(false);

    let controls: IcecontrolSettings[] = [
      new IcecontrolSettings("icelabel", { value: "Thanks you Mr. John Doe", width: "100%", hasFullWidthContainer: true }, null, null),
      new IcecontrolSettings("icelabel", { value: "You are now registered", width: "100%", hasFullWidthContainer: true }, null, null),
      new IcecontrolSettings("ice-qrcode", { value: "Ravikumar potnuru" }, null, null),
      new IcecontrolSettings("icelabel", { value: "AB40222462", width: "100%", hasFullWidthContainer: true }, null, null),
    ];

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings(
        "InboxSection",
        {
          class: ["yalla"],
          styles: {
            width: "100%"
          }
        },
        null,
        controls,
        null)
    ];
    let panels: IcepanelSettings[] = [
      new IcepanelSettings(panelTag, panelKey, "Patient Kiosk - Patient Registration Complete!", "", sections)];

    let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
    this.inboxSettings = new IcepanelcontainerSettings("MessageInbox", panelrows);
  }

}
